import {useAuth} from "react-oidc-context";

const useLogout = () => {
  const auth = useAuth();

  const logout = () => {
    try {
      // Hacer logout del proveedor OIDC
      if (auth.isAuthenticated) {
        auth.signoutRedirect();
      }

      sessionStorage.removeItem("returnUrl");

      return {success: true};
    } catch (error) {
      console.error("Error durante el logout:", error);
      return {success: false, error};
    }
  };

  const logoutWithConfirmation = (message = "¿Estás seguro de que quieres cerrar sesión?") => {
    if (window.confirm(message)) {
      return logout();
    }
    return {success: false, cancelled: true};
  };

  return {
    logout,
    logoutWithConfirmation
  };
};

export default useLogout;
